import React from "react";

import { Form } from "formik-antd";
import { Formik } from "formik";

import { Divider, Button, Modal } from "antd";

import Loader from "../../../components/loader";

import { CloudUploadOutlined, CloseOutlined } from "@ant-design/icons";

const ModalForm = (props) => {
    return (
        <Formik
            enableReinitialize={props.enableReinitialize}
            initialValues={props.initialValues}
            validationSchema={props.validationSchema}
            onSubmit={props.onSubmit}
        >
            {({ values, submitForm, setFieldValue, errors, touched, setFieldTouched, isValid, isSubmitting }) => (
                <Form labelCol={{ xs: 6 }} wrapperCol={{ xs: 14 }}>
                    <Modal
                        title={props.title}
                        visible={props.visible}
                        onOk={submitForm}
                        confirmLoading={isSubmitting}
                        onCancel={props.onCancel}
                        width={props.width ? props.width : 800}
                        footer={[
                            <Button
                                key="back"
                                onClick={props.onCancel}
                                icon={
                                    <>
                                        <CloseOutlined />
                                        <Divider type="vertical" />
                                    </>
                                }
                            >
                                Cancel
                            </Button>,
                            <Button
                                key="submit"
                                loading={isSubmitting}
                                type="primary"
                                onClick={submitForm}
                                icon={
                                    <>
                                        <CloudUploadOutlined />
                                        <Divider type="vertical" />
                                    </>
                                }
                            >
                                {isSubmitting ? "One moment ..." : "Save"}
                            </Button>,
                        ]}
                    >
                        <Loader loading={props.loading} />
                        {!props.loading &&
                            props.render({
                                values,
                                submitForm,
                                setFieldValue,
                                errors,
                                touched,
                                setFieldTouched,
                                isValid,
                                isSubmitting,
                            })}
                    </Modal>
                </Form>
            )}
        </Formik>
    );
};

export default ModalForm;
